import { ICTAFeature } from '@models/ICTAFeature';
import PaginationArrows from '@molecules/PaginationArrows/PaginationArrows';
import PaginationCarousel from '@molecules/PaginationCarousel/PaginationCarousel';
import SoftLoadWrapper from '@molecules/SoftLoadWrapper/SoftLoadWrapper';
import CtaFeature from '@organisms/CtaFeature/CtaFeature';
import { useState } from 'react';
import { SwiperSlide } from 'swiper/react';

interface Props {
  readonly id: string;
  readonly ctaFeatures: ICTAFeature[];
  readonly dividerText: string;
}

const CTAFeaturesCarousel = ({ id, ctaFeatures, dividerText }: Props) => {
  const carouselId = `CTA-Features-Carousel-${id}`;
  const [currentSlideIndex, setCurrentSlideIndex] = useState(1);
  const paginationCounterText = `${currentSlideIndex} ${dividerText} ${
    ctaFeatures.length ?? 0
  }`;

  return (
    <section
      className="component-padding"
      data-testid="CTA-Features-Carousel-Section"
    >
      <SoftLoadWrapper>
        <div className="relative">
          <PaginationCarousel
            autoplay={{
              delay: 5000,
            }}
            dataTestId="CTA-Features-Carousel"
            id={carouselId}
            loop
            paginationClasses={`absolute bottom-[117px] w-full lg:hidden ${
              ctaFeatures.length <= 1 ? 'hidden' : ''
            }`}
            slideChangeCallback={(swiper) => {
              setCurrentSlideIndex(swiper.realIndex + 1);
            }}
          >
            {ctaFeatures.map((ctaFeature) => (
              <SwiperSlide key={ctaFeature.title} className="stretch-card">
                <CtaFeature {...ctaFeature} isInCarousel />
              </SwiperSlide>
            ))}
          </PaginationCarousel>

          {ctaFeatures.length > 1 && (
            <div className="absolute bottom-10 z-[1] flex w-full justify-center max-lg:hidden">
              <PaginationArrows
                carouselNavId={carouselId}
                counterText={paginationCounterText}
                componentName="CTA Features Carousel"
              />
            </div>
          )}
        </div>
      </SoftLoadWrapper>
    </section>
  );
};

export default CTAFeaturesCarousel;
